import { ApiService } from '@services/api';
import { LONG_API_DOMAIN } from '@constants/api';
import {
  IUpdateTikTokAccountProps,
  ISyncTikTokAccountsProps,
} from '@domain/interfaces/dashboard/AdSense/TikTok/ITikTokAccount';

export class TikTokAccountService {
  private readonly apiService: ApiService;

  constructor(baseURL: string) {
    this.apiService = new ApiService(baseURL);
  }

  public syncTikTokAccounts({
    adSenseCredentialAliasId,
    storeAliasId,
  }: ISyncTikTokAccountsProps): Promise<any> {
    return this.apiService.post(
      `/api/v1/users/stores/${storeAliasId}/ad-sense-credentials/${adSenseCredentialAliasId}/tiktok/ad-sense-accounts/sync`,
    );
  }

  public updateTiktokAccount({
    adSenseAccountAliasId,
    adSenseCredentialAliasId,
    data,
    storeAliasId,
  }: IUpdateTikTokAccountProps): Promise<any> {
    return this.apiService.put(
      `/api/v1/users/stores/${storeAliasId}/ad-sense-credentials/${adSenseCredentialAliasId}/tiktok/ad-sense-accounts/${adSenseAccountAliasId}`,
      { ...data },
    );
  }
}

const tikTokAccountService = new TikTokAccountService(LONG_API_DOMAIN);

export default tikTokAccountService;
